export default "__VITE_ASSET__B5IsbdsQ__"